import type { Workstream } from './types';

export function readinessScore(items: Workstream[]): number {
  const weight = items.reduce((sum, item) => sum + item.weight, 0);
  if (!weight) return 0;
  return Math.round(items.reduce((sum, item) => sum + item.percent * item.weight, 0) / weight);
}

export function categoryScores(items: Workstream[]) {
  return (['Commercial', 'Clinical', 'Technology', 'Billing', 'Training'] as const).map(category => ({
    category,
    score: readinessScore(items.filter(item => item.category === category)),
  }));
}

